import "!../../node_modules/mini-css-extract-plugin/dist/loader.js?{}!css-loader?{\"modules\":false,\"url\":false}!./img.treat.3zf70Ti.css";
export var imgStyles = {base:'_1u1a_',inline:'jcQEH',contain:'_2943V',cover:'_3VqQ5'};